export default "__VITE_ASSET__BR0wpQx5__"